import React from 'react';

function Chat() {
  return (
    <section className="tc-chat-style1">
      <div className="container">
        <div className="content">
          <a href="https://www.instagram.com/perlareoficial/" target='_blank' className="xl-text">
            @perlareoficial
          </a>
          <h5 className="mb-50 lh-5">
            Nos siga no Instagram e fique por dentro <br/> de todas as novidades 
          </h5>
        </div>
      </div>
      <img src="/home1/assets/img/c_line4.png" alt="" className="c-line wow" />
    </section>
  );
}

export default Chat;
